import { getRequest, postRequest, putRequest, deleteRequest } from './axios'
import { getActiveTenant } from './tenant'
import { INTERCOM_USER_ID_PREFIX } from './constants'

// ===================== GET REQUESTS =====================
export const getRegistrationFields = () =>
  getRequest('/tenant/get-registration-fields')
export const checkIsEmailUnique = (params = {}) =>
  getRequest('/user/check-unique-constraints', params)
export const checkIsUsernameUnique = (params = {}) =>
  getRequest('/user/check-unique-constraints', params)
export const getGameCategory = (params = {}) =>
  getRequest('casino/category', params)
export const getGameSubCategory = (params = {}) =>
  getRequest('casino/sub-category', params)
export const getCasinoMenus = (params = {}) =>
  getRequest('/tenant/get-casino-menus', params)
export const getCasinoMenuItems = (params = {}) =>
  getRequest('/tenant/get-menu-items', params)
export const getLobbyData = () =>
  getRequest('/tenant/get-menus-item')
export const getTenantDetails = () =>
  getRequest('/tenant/get-tenant-detail')
export const getAllCountries = () =>
  getRequest('/tenant/get-all-country')
export const getProviders = (params = {}) =>
  getRequest('/casino/provider', params)
export const getStudios = (params = {}) =>
  getRequest('/casino/studios', params)
export const getUserDetails = () =>
  getRequest('/user/get-user-details', { intercomPrefix: INTERCOM_USER_ID_PREFIX })
export const getUserKYCStatus = (params = {}) =>
  getRequest('/user/kyc-status', params)
export const getFavoriteGame = (params = {}) =>
  getRequest('/casino/favorite', params)
export const getUserBetHistory = (params = {}) =>
  getRequest('/user/get-casino-transactions', params)
export const getUserCredential = (params = {}) =>
  getRequest('/user/init-pay', params)
export const getWithdrawalHistory = (params = {}) =>
  getRequest('/user/get-withdraw-requests', params)
export const getDocumentsLabel = () =>
  getRequest('/document/get-document-label')
export const getDocuments = () =>
  getRequest('/document/get-documents')
export const getAllBonus = (params = {}) =>
  getRequest('/tenant/get-all-bonus', params)
export const getBonusDetail = (params = {}) =>
  getRequest('/tenant/bonus-detail', params)
export const getUserBonus = (params = {}) =>
  getRequest('/user/get-user-bonus', params)
export const getUserTransactions = (params = {}) =>
  getRequest('/user/get-user-transactions', params)
export const getSportsBookTransactions = (params = {}) =>
  getRequest('/user/sports-book-transactions', params)
export const getLoyaltyLevel = () =>
  getRequest('/tenant/get-loyalty-level')
export const getLoyaltyDetails = () =>
  getRequest('/user/get-loyalty-details')
export const getCmsPage = (params = {}) =>
  getRequest('/tenant/get-cms-page', params)
export const getAllGames = (params = {}) =>
  getRequest('/casino/games', params)
export const getLimitTable = (params = {}) =>
  getRequest('/user/get-limit-table', params)
export const getLanguages = () =>
  getRequest('/tenant/get-languages')
export const getComponentConfig = () =>
  getRequest('/tenant/components-config')
export const getLanguageData = (params = {}) =>
  getRequest('/user/get-language-support-keys', params)
export const getTopGames = (params = {}) =>
  getRequest('/casino/top-games', params)
export const getTopWinners = (params = {}) =>
  getRequest('/user/get-top-winners', params)
export const getTopPlayers = () =>
  getRequest('/tenant/top-players')
export const getHighWinners = (params = {}) =>
  getRequest('/user/high-winners', params)
export const getLuckyWinners = (params = {}) =>
  getRequest('/user/lucky-winners', params)
export const getCurrentWinners = (params = {}) =>
  getRequest('/user/get-current-winners', params)
export const getPaymentProviders = (params = {}) =>
  getRequest('/tenant/get-payment-providers', params)
export const getPaymentStatus = (params = {}) =>
  getRequest('/user/payment-status', params)
export const getSumSubAccessToken = () =>
  getRequest('/document/init-access-token')
export const getAllReviews = () =>
  getRequest('/tenant/get-reviews')
export const getCashbackBalance = () =>
  getRequest('/user/cashback-balance')
export const getAntetrekPopupToken = () =>
  getRequest('/user/antetrek-popup-token')
export const getCashbackTable = () =>
  getRequest('/tenant/get-cashback-bonus')
export const getWalletAmount = () =>
  getRequest('/user/wallet-amount')
export const getCasinoProvider = (params = {}) =>
  getRequest('/user/get-all-category-providers', params)
export const getCasinoStudio = (params = {}) =>
  getRequest('/user/category-studios', params)
export const getTournament = (params = {}) =>
  getRequest('/api/tournament', params)
export const getTournamentDetails = (params = {}) =>
  getRequest('/tournament/details', params)
export const getRecentGames = (params = {}) =>
  getRequest('casino/recent-games', params)
export const changePhoneNumber = (params = {}) =>
  getRequest('/user/phone-otp', params)
export const resendPhoneOTP = (params = {}) =>
  getRequest('/user/phone-otp', params)
export const getUtorgCurrencies = () =>
  getRequest('/user/utorg-currencies')
export const getTenantConfig = (params = {}) =>
  getRequest(`/config/${getActiveTenant()}.json`, params, { ignoreAuthorization: true, baseURL: '' })
export const getBaseTranslations = () =>
  getRequest('/locales/default.json', {}, { ignoreAuthorization: true, baseURL: '' })

// ===================== POST REQUESTS =====================
export const userLogin = (data = {}) =>
  postRequest('/user/login', data)
export const userSignUp = (data = {}) =>
  postRequest('/user/sign-up', data, {}, { customHeaders: { mirrorSiteDomain: window.location.origin } })
export const playGame = (data = {}) =>
  postRequest('/casino/play', data)
export const demoGame = (data = {}) =>
  postRequest('/casino/play-demo', data)
export const addFavoriteGame = (data = {}) =>
  postRequest('/casino/favorite', data)
export const verifyEmail = (data = {}) =>
  postRequest('/user/verify-email', data)
export const resendEmail = (data = {}) =>
  postRequest('/user/refresh-email-token', data, {}, { customHeaders: { mirrorSiteDomain: window.location.origin } })
export const forgetPassword = (data = {}) =>
  postRequest('/user/forget-password', data)
export const resetPassword = (data = {}) =>
  postRequest('/user/verify-forget-password', data)
export const resetEmail = (data = {}) =>
  postRequest('/user/reset-email', data)
export const addBrowserId = (data = {}) =>
  postRequest('/user/insert-unique-key', data)
export const claimBonus = (data = {}) =>
  postRequest('/user/avail-bonus', data)
export const setDailyLimit = (data = {}) =>
  postRequest('/user/set-daily-limit', data)
export const setLossLimit = (data = {}) =>
  postRequest('/user/set-loss-limit', data)
export const setDepositLimit = (data = {}) =>
  postRequest('/user/set-deposit-limit', data)
export const setSessionTime = (data = {}) =>
  postRequest('/user/set-session-time', data)
export const setDisableUntil = (data = {}) =>
  postRequest('/user/set-disable-until', data)
export const logout = (data = {}) =>
  postRequest('/user/logout', data)
export const verifyPayment = (data = {}) =>
  postRequest('/user/validate-payment', data)
export const playTournamentGame = (data = {}) =>
  postRequest('/user/init-tournament-game', data)
export const stopGamePlayTimer = () =>
  postRequest('/user/update-game-limit')
export const rotateAccessToken = (data = {}) =>
  postRequest('/user/rotate-token', data)

// ===================== PUT REQUESTS =====================
export const updateUserDetails = (data = {}) =>
  putRequest('/user/update-user-details', data)
export const uploadProfileImage = ({ data }) =>
  putRequest('/user/upload-profile-image', data)
export const removeProfileImage = (data = {}) =>
  putRequest('/user/remove-profile-image', data)
export const cancelWithdrawRequest = (data = {}) =>
  putRequest('/user/cancel-withdraw-request', data)
export const updateDocuments = ({ data }) =>
  putRequest('/document/update-user-document', data)
export const availBonus = ({ data }) =>
  putRequest('/user/avail-bonus', data)
export const setGamePlayLimit = (data = {}) =>
  putRequest('/user/game-play-limit', data)
export const submitOTP = (data = {}) =>
  putRequest('/user/phone-otp', data)

// ===================== DELETE REQUESTS =====================
export const removeFavoriteGame = (data = {}) =>
  deleteRequest('casino/favorite', data)
export const cancelBonus = ({ data }) =>
  deleteRequest('/user/cancel-bonus', data)

export const getCalendar = () => {
  return getRequest('/tenant/promotional-calendar')
}
